import * as React from 'react';
export const billieSvg = React.forwardRef(function billieSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#1C1C1E',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M22.968 10.853c0 .856-.097 1.792-.283 2.666l.003-.002c1.747 1.328 2.78 3.345 2.78 5.48 0 3.86-3.305 7.003-7.363 7.003H8.25V11.004c0-1.925.844-3.786 2.316-5.104A7.537 7.537 0 0 1 15.6 4c.16 0 .322.006.481.014 3.795.228 6.887 3.296 6.887 6.84Zm-7.884 11.87h3.015c2.157 0 3.913-1.67 3.913-3.724 0-1.025-.434-1.95-1.136-2.624-1.33 2.412-3.228 4.493-5.792 6.349Zm4.27-10.117a9.985 9.985 0 0 0 .168-1.756c0-1.841-1.64-3.443-3.656-3.563a3.994 3.994 0 0 0-2.933 1.003c-.797.713-1.237 1.677-1.237 2.716v1.6h7.658Zm-1.255 2.666h-6.408v6.452c3.089-1.875 5.21-3.942 6.624-6.447-.07-.005-.145-.005-.216-.005Z',
      fill: '#fff',
    }),
  );
});
billieSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var billie = {
  category: 'brand',
  colorable: false,
  name: 'billie',
  svg: billieSvg,
};
